import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Modal, {
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalTitle,
} from '../../../../components/bootstrap/Modal';
import Icon from '../../../../components/icon/Icon';
import Card, {
    CardActions,
    CardBody,
    CardHeader,
    CardLabel,
    CardTitle,
} from '../../../../components/bootstrap/Card';
import { Dots } from 'loading-animations-react';
import OffCanvas, {
    OffCanvasBody,
    OffCanvasHeader,
    OffCanvasTitle,
} from '../../../../components/bootstrap/OffCanvas';
// import FormGroup from '../../../../components/bootstrap/forms/FormGroup';
import Input from '../../../../components/bootstrap/forms/Input';
import Textarea from '../../../../components/bootstrap/forms/Textarea';
import Checks from '../../../../components/bootstrap/forms/Checks';
import Popovers from '../../../../components/bootstrap/Popovers';
import Button from '../../../../components/bootstrap/Button';
import { useFormik } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import Select from 'react-select'
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import DelphiLogger from '../../../../services/DelphiLogger';
import FileService from '../../../../services/FileService';
import { FileDropPad } from './FileDropPad';

export const AddFileModal = ({ setIsOpen, isOpen, curProject, callback }) => {

    const FileTypeOptions = [
        { value: 'PDF', label: 'PDF' },
        { value: 'PowerPoint', label: 'PowerPoint' },
        { value: 'Other', label: 'Other' }
    ]

    const [isLoading, setIsLoading] = useState(false)
    const [filesToAdd, setFilesToAdd] = useState([])

    const updateInfo = (i, newInfo) => {
        var newF = [...filesToAdd]
        newF[i] = newInfo
        setFilesToAdd(newF)
    }

    const deleteFileInfo = (i) => {
        var newF = [...filesToAdd]
        newF.splice(i, 1);
        setFilesToAdd(newF)
    }

    const startFileAdd = (files) => {
        const newF = [...filesToAdd]

        Object.keys(files).map(function (key, index) {

            const file = files[key]
            var fileExtRe = /(?:\.([^.]+))?$/;
            var matches = fileExtRe.exec(file.name);
            if (matches.length < 1) {
                throw Error('File Name is invalid and cannot determine extension')
            }
            const extension = matches[1]
            var type = "Other"
            switch (extension) {
                case 'pdf':
                    type = "PDF"
                    break;
                case 'ppt':
                case 'pptx':
                    type = "PowerPoint"
                    break;
            }

            newF.push({
                'title': file.name,
                'description': '',

                'file': file,
                'type': type
            })
        });
        setFilesToAdd(newF)
    }

    const addFiles = async () => {
        try {
            DelphiLogger.logMessage(`Uploading ${filesToAdd.filter(x => !x.toDelete).length} files`)
            const filesCreated = await FileService.uploadFiles(filesToAdd.map(f => f.file), curProject)
            DelphiLogger.logMessage(`Updating FileInfo for ${filesToAdd.length} files`)

            filesCreated.map((fileCreated, i) => {
                var fileInfo = filesToAdd.find(f => f?.file?.name == fileCreated.filename)
                delete fileInfo.file
                fileInfo._id = fileCreated._id
            })

            await FileService.putFileInfo(filesToAdd)
            DelphiLogger.logMessage(`Success: Uploaded ${filesToAdd.length} files`)

            if (callback) {
                await callback()
            }
            setFilesToAdd([])
            setIsOpen(false)
        }
        catch (err) {
            DelphiLogger.logError("File Upload failed", err.message)
        }
    }

    const _addFiles = async () => {
        setIsLoading(true)
        try {
            await addFiles()
        } catch (error) {
            DelphiLogger.logError("File Upload failed")
        }
        setIsLoading(false)
    }

    return (
        isLoading ?
            <PageWrapper className="justify-content-center text-center" title="Tasks">
                <div className=" justify-content-center text-center" title="Tasks">
                    <Dots></Dots>
                </div>
            </PageWrapper> :
            <Modal
                setIsOpen={setIsOpen}
                isOpen={isOpen}
                titleId='upcomingEdit'
                isCentered
                isScrollable
                size='lg'>
                <ModalHeader setIsOpen={setIsOpen}>
                    <OffCanvasTitle id='upcomingEdit'>Add Files to Deal: '{curProject?.title}'</OffCanvasTitle>
                </ModalHeader>
                <ModalBody>
                    <div className='row g-4'>
                        <div className='col-12'>

                        </div>
                        <div className='col-12'>
                            <Card isCompact className='mb-0'>
                                <CardHeader>
                                    <FileDropPad startFileAdd={startFileAdd} />
                                    <br />
                                    <br />
                                </CardHeader>
                                <CardBody >
                                    {
                                        filesToAdd?.length > 0 &&
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col"></th>
                                                    <th style={{ width: "20%" }} scope="col">File Name</th>
                                                    <th style={{ width: "50%" }} scope="col">Description</th>
                                                    <th style={{ width: "20%" }} scope="col">Type</th>
                                                    <th style={{ width: "10%" }} scope="col">Size</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    filesToAdd.map((file, i) => {
                                                        return (
                                                            <tr>
                                                                <th scope="row"><div><FontAwesomeIcon className='deleteIcon' size='' icon={faTrashCan} onClick={() => deleteFileInfo(i)} /></div>  </th>
                                                                <td><span contentEditable onBlur={(e) => updateInfo(i, { ...file, title: e.currentTarget.textContent })}>{file.title}</span></td>
                                                                <td><span contentEditable onBlur={(e) => updateInfo(i, { ...file, description: e.currentTarget.textContent })}>{file.description}</span></td>
                                                                <td><Select options={FileTypeOptions} onChange={(v) => updateInfo(i, { ...file, type: v.value })} value={{ value: file.type, label: file.type }} /></td>
                                                                <td>{file?.file?.size} B</td>
                                                            </tr>)
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    }
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className='bg-transparent'>
                    <Button color="warning" onClick={() => setFilesToAdd([])}>
                        Clear
                    </Button>
                    <Button color="success" onClick={async () => await _addFiles()}>
                        Upload
                    </Button>
                </ModalFooter>
            </Modal>
    )
}
